/**
 * Permissões do Clube de Benefícios no front (CLUBE-04, spec §8).
 *
 * Mora ao lado da feature que governa, no mesmo padrão de
 * `features/dashboard/permissoes-dashboard.ts`. `features/auth/permissions.ts`
 * continua sendo o espelho CRU da matriz do backend — é o que o guardrail
 * `permissions.rbac-mirror.test.ts` compara com `rbac-backend-matrix.generated.json`
 * — e não é lugar de regra de tela. Aqui só se declara QUAIS permissões abrem
 * a porta do módulo.
 *
 * São as ações `ver` dos dez recursos da spec §8. `ver` e não o conjunto
 * inteiro de ações porque quem não pode ver nada do clube não tem o que abrir,
 * e os três perfis semente (Gestor, Operação e Financeiro do Clube) têm pelo
 * menos um `ver` — logo, "alguma permissão `clube_*`" e "algum `clube_*:ver`"
 * selecionam exatamente a mesma população hoje.
 *
 * Isto é dica de UI. A autorização real é do backend Go, que devolve 403
 * mesmo se a tela deixasse o caminho aberto.
 */

import { temPermissao } from '@/features/auth/permissions'

/** Os dez recursos da spec §8, na ação de leitura. */
export const PERMISSOES_CLUBE: string[] = [
  'clube_catalogo:ver',
  'clube_membro:ver',
  'clube_financeiro:ver',
  'clube_chamado:ver',
  'clube_agenda:ver',
  'clube_repasse:ver',
  'clube_parceiro:ver',
  'clube_pontos:ver',
  'clube_config:ver',
  'clube_indicador:ver',
]

/**
 * podeVerClube — o usuário tem ALGUMA permissão do clube.
 *
 * É metade do portão do menu; a outra metade é a flag mestre
 * `clube.habilitado` (ver `use-clube-habilitado.ts`). As duas condições
 * precisam valer, e é isso que o teste de navegação cobre nas quatro
 * combinações.
 */
export function podeVerClube(perfis?: string[]): boolean {
  return PERMISSOES_CLUBE.some((p) => temPermissao(perfis, p))
}
